import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Config } from "../../Config";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import "./MobileProductCategory.scss";
import "./Responsive.scss";

const MobileProductCategory = (props) => {
  const [category, setCategory] = useState([]);
  const user = useSelector((state) => state.user);
  useEffect(() => {
    Config.pageUp();
    getCategories();
  }, []);

  const getCategories = () => {
    axios
      .get(
        "Product/GetProductCategory",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setCategory(result.data.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const breadCrumbData = [{ title: "خانه", link: "/" }];
  const showProduct = (id) => {
    props.history.replace({
      pathname: `/products`,
      state: { categoryId: id },
    });
  };
  return (
    <section className="MobileProductCategory">
      <Helmet>
        {/* <title>ایران رگالو | دسته بندی محصولات</title> */}
        <title>{Config.helmetTitle} | دسته بندی محصولات</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <BreadCrumb breadCrumbData={breadCrumbData} />
      <div className="ctIdContent">
        <div className="desktop">
          <div className="categoryBox">
            <div className="categoryItems">
              <span className="categoryItemsTitle">دسته بندی محصولات</span>
              {category.map((item, index) => {
                return (
                  <span key={index} onClick={() => showProduct(item.id)} className="categoryItem">
                    {item.categoryName}
                  </span>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(withRouter(MobileProductCategory));
